// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__vRc+z"};